module.exports = __webpack_public_path__ + "img/rightbicep-endo-mesomorph-male.f053bc7c.svg";